import React from 'react';
import { Button } from './Button';
import { ShieldCheck, Clock } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function Pricing() {
  return <section id="pricing" className="py-20 bg-white relative overflow-hidden" data-id="element-147">
      {/* Decorative Background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-brand-light/50 rounded-full blur-3xl -z-10" data-id="element-148"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-149">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-teal mb-6" data-id="element-150">
          Recuperá a tu hijo por el valor de una sola sesión de terapia.
        </h2>

        <p className="text-xl text-gray-600 mb-12" data-id="element-151">
          Todo el protocolo, las guías y los bonus, acceso inmediato y de por
          vida.
        </p>

        <div className="bg-white rounded-3xl shadow-2xl border-2 border-brand-gold pt-12 pb-8 px-6 md:pt-14 md:pb-12 md:px-12 max-w-2xl mx-auto relative" data-id="element-152">
          {/* Urgency tag - responsive positioning */}
          <div className="absolute -top-4 sm:-top-5 left-1/2 -translate-x-1/2 bg-red-600 text-white px-4 sm:px-6 py-1.5 sm:py-2 rounded-full font-bold flex items-center gap-1.5 sm:gap-2 shadow-lg text-xs sm:text-sm whitespace-nowrap max-w-[calc(100%-2rem)]" data-id="element-153">
            <Clock className="w-4 h-4 sm:w-5 sm:h-5 animate-pulse shrink-0" data-id="element-154" />
            <span data-id="element-155">OFERTA TERMINA PRONTO</span>
          </div>

          <div className="mb-8" data-id="element-156">
            <p className="text-gray-500 text-base sm:text-lg line-through mb-2" data-id="element-157">
              Precio Sugerido: $29.900 ARS
            </p>
            <div className="flex justify-center items-baseline gap-2 text-brand-teal" data-id="element-158">
              <span className="text-5xl sm:text-6xl font-black tracking-tight" data-id="element-159">
                $9.990
              </span>
              <span className="text-lg sm:text-xl font-bold" data-id="element-160">ARS</span>
            </div>
            <p className="text-brand-gold font-bold mt-2 text-sm sm:text-base" data-id="element-161">
              (Aprox. USD 12.97 para resto de Latam)
            </p>
          </div>

          <div className="px-0 sm:px-4" data-id="element-162">
            <Button href="https://www.elplacerquenutre.com/cart/45339963195494:1" onLinkClick={() => trackAddToCart({
            content_name: 'Protocolo Intestino Limpio, Mente Sana',
            value: 9.99,
            currency: 'USD'
          })} fullWidth className="text-base sm:text-xl py-4 sm:py-5 mb-6 shadow-xl" data-id="element-163">
              DESBLOQUEAR EL PROTOCOLO COMPLETO
            </Button>
          </div>

          <p className="text-sm text-gray-500 mb-8" data-id="element-164">
            Pago único. Acceso inmediato al material digital.
          </p>

          {/* Guarantee Box */}
          <div className="bg-brand-light rounded-xl p-5 sm:p-6 border border-brand-teal/20 text-left flex flex-col sm:flex-row gap-4 sm:gap-6 items-center sm:items-start" data-id="element-165">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-brand-teal rounded-full flex items-center justify-center shrink-0" data-id="element-166">
              <ShieldCheck className="w-7 h-7 sm:w-8 sm:h-8 text-brand-gold" data-id="element-167" />
            </div>
            <div className="text-center sm:text-left" data-id="element-168">
              <h4 className="font-bold text-brand-dark text-base sm:text-lg mb-2" data-id="element-169">
                Garantía de "Mirada Sostenida"
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-170">
                Prueba el plan por 7 días. Si el sueño de tu hijo no mejora o su
                inflamación no baja, te devuelvo el 100% de tu dinero sin hacer
                preguntas.{' '}
                <strong className="text-brand-teal" data-id="element-171">El riesgo es mío.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}